import React, { PureComponent } from 'react'

export const ActiveInactiveComponent = (props) => {
  const { value } = props
  return <div>{value ? 'Yes' : 'No'}</div>
}

export default ActiveInactiveComponent



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/ActiveInactiveComponent.js